export const extractOAuthParams = (location: any) => {
  const queryParams = new URLSearchParams(location.search.substring(1))
  const oAuthPartnerParams = {}
  queryParams.forEach((value, key) => {
    oAuthPartnerParams[key] = value
  })

  return {
    preservedRedirect: location.pathname + location.search,
    preservedQueryParams: location.search,
    chromeExtensionPartnerFlow: oAuthPartnerParams.hasOwnProperty('client_id'),
    oAuthPartnerParams,
  }
}
